import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminRecordedSchema } from "./common.js";
/** Mail Crux sent, against the sender's daily cap. */
export const adminEmailsSchema = z.object({
    asOf: z.string(),
    capPerDay: adminCountSchema,
    daily: z.array(z.object({
        day: adminDaySchema,
        weekly: adminCountSchema,
        monthly: adminCountSchema,
        alerts: adminCountSchema,
        failed: adminCountSchema,
    })),
    kinds: z.array(z.object({
        kind: z.string(),
        label: z.string(),
        sent: adminCountSchema,
        failed: adminCountSchema,
        pending: adminCountSchema,
    })),
    failures: z.array(z.object({ at: z.string(), kind: z.string(), error: z.string() })),
    /** Sign-in links are not in `email_sends` today, only their tokens are. */
    loginLinks: adminRecordedSchema(adminCountSchema),
});
//# sourceMappingURL=emails.js.map